import { render, staticRenderFns } from "./DashboardBanner.vue?vue&type=template&id=472e6de4&scoped=true&"
import script from "./DashboardBanner.vue?vue&type=script&lang=js&"
export * from "./DashboardBanner.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBanner.vue?vue&type=style&index=0&id=472e6de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472e6de4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
